export default __webpack_public_path__ + "static/media/alert-triangle.c38c806a.svg";